package one.healthium.decompose

import androidx.compose.animation.core.tween
import com.arkivanov.decompose.extensions.compose.stack.animation.StackAnimation
import com.arkivanov.decompose.extensions.compose.stack.animation.StackAnimationProvider
import com.arkivanov.decompose.extensions.compose.stack.animation.stackAnimation

object DefaultStackAnimationProvider : StackAnimationProvider {
    private val defaultAnimSpecs = tween<Float>(
        durationMillis = 450,
        delayMillis = 100,
    )

    private val defaultAnimator = parallax(defaultAnimSpecs)

    override fun <C : Any, T : Any> provide(): StackAnimation<C, T> {
        return stackAnimation(defaultAnimator)
    }
}